// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"36a20004","160":"1486121d","208":"70ca4e44","293":"de9f399e","516":"c8d11de1","519":"b278eb95","906":"ae2ce0c5","917":"7085f100","946":"b781484e"}[chunkId] + ".chunk.js";
};